import Vue from "vue"
import App from "./App.vue"
import VueScrollactive from "vue-scrollactive"
import ReadMore from "vue-read-more"
import "@/assets/css/main.scss"

Vue.use(VueScrollactive)
Vue.use(ReadMore)

Vue.config.productionTip = false

Vue.filter("truncate", function(value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + "..."
  }

  return value
})

new Vue({
  render: (h) => h(App),
}).$mount("#app")
